import { Table, ConfigProvider, Grid, Input } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import Header from '../../components/Header/Header';
import axios from 'axios';
import { themeConfig } from '../WalletTransactions/config';
import { StyledPagination } from '../../components/table.style';
import { useConfigurationContext } from '../../store/configurationContext';
import { columns } from './columns';
import { useDirectionContext } from '../../store/DirectionContext';

const formatDate = (iso: any) => {
	if (!iso) return '';
	const date = new Date(iso);
	return date.toISOString().split('T')[0]; // returns "YYYY-MM-DD"
};
const HolidaysList = () => {
	const { t } = useTranslation();
	const { lg } = Grid.useBreakpoint();
	const { directionState } = useDirectionContext();
	const [holidaysListLoading, setHolidaysListLoading] = useState(false);
	const [holidaysList, setHolidaysList] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [filterdData, setFilteredData] = useState([]);
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';

	const getHolidayList = () => {
		setHolidaysListLoading(true);
		axios
			.get(`${API_ENDPOINTS.getHolidayList}`)
			.then((res) => {
				setHolidaysList(res.data);
				setFilteredData(res.data);
				setTotalElements(res.data.length);
			})
			.catch(console.error)
			.finally(() => setHolidaysListLoading(false));
	};
	useEffect(() => {
		getHolidayList();
	}, []);

	useEffect(() => {
		const data = holidaysList.filter((item: any) => {
			const values = [];

			// Push all non-array, non-null values
			for (const key in item) {
				const value = item[key];
				if (Array.isArray(value)) {
					values.push(...value);
				} else if (value !== null) {
					values.push(value);
				}
			}

			// Add formatted date range to search
			const dateRange = `${formatDate(item.startDate)} → ${formatDate(item.endDate)}`;
			values.push(dateRange);

			// Check if searchTerm matches anything
			return values.some((val) => String(val).toLowerCase().includes(searchTerm.toLocaleLowerCase()));
		});
		setFilteredData(data);
	}, [searchTerm]);
	const holidaysTableColumns = useMemo(
		() =>
			columns({
				isMobile: !lg,
				translate: t,
				refetch: getHolidayList,
				isLtr: directionState === 'ltr',
			}),
		[lg, t],
	);

	return (
		<div className='currencies-container'>
			<Header title={t<string>('Holidays')} description={t<string>('')} />
			<div className='min-h-[84vh] mx-auto px-5 py-5 bg-white '>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('searchHoliday')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={holidaysTableColumns}
							dataSource={filterdData}
							loading={holidaysListLoading}
							tableLayout='fixed'
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
		</div>
	);
};

export default HolidaysList;
